import {AbstractService} from "@/services/AbstractService";
import {Purchase} from "@/services/pixel/events/shopify/Purchase";
import {AddToCart} from "@/services/pixel/events/shopify/AddToCart";

import {Ping} from "@/services/pixel/events/debug/Ping";
import {Flush} from "@/services/pixel/events/debug/Flush";
import {Error} from "@/services/pixel/events/debug/Error";

import {AttributionsUpdate} from "@/services/pixel/actions/shopify/AttributionsUpdate";
import {AddPaymentInfo} from "@/services/pixel/events/shopify/AddPaymentInfo";
import {AddShippingInfo} from "@/services/pixel/events/shopify/AddShippingInfo";
import {InitiateCheckout} from "@/services/pixel/events/shopify/InitiateCheckout";
import {PageView} from "@/services/pixel/events/shopify/PageView";
import {Log} from "@/services/pixel/Log";
import {ViewCart} from "@/services/pixel/events/shopify/ViewCart";
import {ViewContent} from "@/services/pixel/events/shopify/ViewContent";
import {NewsletterSubscription} from "@/services/pixel/events/shopify/NewsletterSubscription";

export class Pixel extends AbstractService {
  log = new Log();

  events = {
    debug: {
      ping: new Ping(),
      flush: new Flush(),
      error: new Error(),
    },
    shopify: {
        pageView: new PageView(),
        addToCart: new AddToCart(),
        initiateCheckout: new InitiateCheckout(),
        addShippingInfo: new AddShippingInfo(),
        addPaymentInfo: new AddPaymentInfo(),
        purchase: new Purchase(),

        viewCart: new ViewCart(),
        viewContent: new ViewContent(),

        // addToWishlist: null,
        // contact: null,
        // customizeProduct: null,
        // lead: null,
        // search: null,
        // viewCategory: null,


        newsletterSubscription: new NewsletterSubscription(),
    }
  };

  actions = {
      shopify: {
          attributionsUpdate: new AttributionsUpdate(),
      }
  };
}
